import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Box, Button } from "@material-ui/core";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { getCookie } from "../../services/Cookies";
import { getRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ddd",
    fontWeight: "bold",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles({
  tableLayout: {
    boxShadow: "0 0 0 0 #fff !important",
  },
  table: {
    minWidth: 650,
  },
  boxBorder: {
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  overflowHidden: {
    overflow: "hidden",
    height: "20px",
  },
  arrowIcons: {
    fontSize: "46px",
    marginTop: "-12px",
  },
  btnShow: {
    border: "2px solid #ff4717",
    textTransform: "capitalize",
    color: "#000",
  },
});

function CustomerContractDetails(props) {
  const history = useHistory();
  const classes = useStyles();
  const title = "Atlanta_1";
  const [customerBox, setCustomerBox] = React.useState(true);
  const [contractDetails, setContractDetails] = React.useState([]);
  const { customerContractList } = props;
  useEffect(() => {
    // getContractDetails("5113161");
  }, []);

  const getContractDetails = (contractkey) => {
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Ship/ContractsDetails/${contractkey}`;
    getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          setContractDetails(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  };
  return (
    <div>
      <Box component="div" bgcolor="#fff" boxShadow={1} borderRadius={6}>
        <Box
          component="div"
          bgcolor="#1A1A31"
          py={1.0}
          px={3}
          fontWeight={600}
          fontSize={15}
          color="#fff"
          className={classes.boxBorder}
        >
          <Box display="flex" className={classes.justifyContentBetween}>
            <Box component="span" fontSize="18px">
              Customer and Contract Details
            </Box>
            <Box
              component="span"
              width="0.03"
              className={classes.overflowHidden}
            >
              <Box display={customerBox ? "inline" : "none"} component="span">
                <ArrowDropDownIcon
                  className={classes.arrowIcons}
                  onClick={() => {
                    setCustomerBox(!customerBox);
                  }}
                />
              </Box>

              <Box display={!customerBox ? "inline" : "none"} component="span">
                <ArrowDropUpIcon
                  className={classes.arrowIcons}
                  onClick={() => {
                    setCustomerBox(!customerBox);
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box component="div" display={customerBox ? "block" : "none"}>
          <Box component="div">
            <TableContainer component={Paper} className={classes.tableLayout}>
              <Table className={classes.table} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    {/* <StyledTableCell>Service</StyledTableCell> */}
                    <StyledTableCell>Contract Number</StyledTableCell>
                    <StyledTableCell>VPS Sales person</StyledTableCell>
                    <StyledTableCell>Contact</StyledTableCell>
                    <StyledTableCell>Customer</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    customerContractList.length
                      ? customerContractList.map((row) => (
                          <TableRow key={row.name}>
                            {/* <TableCell>
                              {row.service ? row.service : ""}
                            </TableCell> */}
                            <TableCell>
                              {row.contractNumber ? row.contractNumber : ""}
                            </TableCell>
                            <TableCell>
                              {row.vpsSalesPerson ? row.vpsSalesPerson : ""}
                            </TableCell>
                            <TableCell>
                              {row.contact ? row.contact : ""}
                            </TableCell>
                            <TableCell>
                              {row.customer ? row.customer : ""}
                            </TableCell>
                            <TableCell>
                              {row.status ? row.status : ""}
                            </TableCell>
                          </TableRow>
                        ))
                      : ""
                    //  (
                    //   <TableRow>
                    //     <TableCell colSpan="6" style={{ textAlign: "center" }}>
                    //       Loading....
                    //     </TableCell>
                    //   </TableRow>
                    // )
                  }
                </TableBody>
                <TableBody>
                  {!customerContractList.length ? (
                    <TableRow>
                      <TableCell colSpan="6" style={{ textAlign: "center" }}>
                        No data found
                      </TableCell>
                    </TableRow>
                  ) : (
                    ""
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          {/*<Box component="div" textAlign="center" py={3}>
            <Button
              className={classes.btnShow}
              variant="outlined"
              // onClick={() => {
              //  history.push(
                 // `/dashboard/assets/${title}/${"customer-contract-details"}`
                //);
              //}} 
            >
              Show more
            </Button>
                  </Box>*/}
        </Box>
      </Box>
    </div>
  );
}

export default CustomerContractDetails;
